module.exports = __webpack_public_path__ + "img/FW_ShowHuan.061eab42.jpg";